import { MetricKpiCard } from "@/features/dashboard/shell";
import { OverviewSection } from "@/features/dashboard/hub/OverviewSection";

import {
  MOCK_PATIENTS_SPARK,
  MOCK_PATIENTS_TODAY,
  MOCK_PATIENTS_TOTAL,
} from "./mock-data";

/**
 * Overview mock de pacientes.
 */
export function PatientsOverview(): React.JSX.Element {
  return (
    <OverviewSection
      title="Pacientes"
      description="Registros de pacientes"
      isMock
    >
      <div className="grid grid-cols-2 gap-3">
        <MetricKpiCard
          label="Registrados hoy"
          value={MOCK_PATIENTS_TODAY}
          hint="Altas de pacientes en el día (mock)"
          sparkline={MOCK_PATIENTS_SPARK}
        />
        <MetricKpiCard
          label="Total registrados"
          value={MOCK_PATIENTS_TOTAL.toLocaleString("es")}
          hint="Acumulado (mock)"
        />
      </div>
    </OverviewSection>
  );
}
